<template>
  <div class="list">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        订单列表
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px" @click="geting()">刷新</div>
        </div>
      </div>
    </div>
    <noAccess v-if="showNoAccess"></noAccess>
    <div v-else style="width: 1056px;margin: 0 auto">
      <div class="menu1">
        <button
          class="btn3 clear-item"
          @click="setType()"
          v-bind:class="{ active: resType == null }"
        >
          全部订单(
          <i>{{count0}}</i>
          )
        </button>
        <button class="btn3 clear-item" @click="setType(0)" v-bind:class="{ active: resType == 0}">
          待付款(
          <i>{{count1}}</i>
          )
        </button>
        <button class="btn3 clear-item" @click="setType(1)" v-bind:class="{ active: resType == 1 }">
          待采购(
          <i>{{count2}}</i>
          )
        </button>
        <button class="btn3 clear-item" @click="setType(2)" v-bind:class="{ active: resType == 2 }">
          待发货(
          <i>{{count3}}</i>
          )
        </button>
        <button class="btn3 clear-item" @click="setType(3)" v-bind:class="{ active: resType == 3 }">
          待收货(
          <i>{{count4}}</i>
          )
        </button>
        <button class="btn3 clear-item" @click="setType(4)" v-bind:class="{ active: resType == 4 }">
          待评价(
          <i>{{count5}}</i>
          )
        </button>
        <button class="btn3 clear-item" @click="setType(5)" v-bind:class="{ active: resType == 5 }">
          已完成(
          <i>{{count6}}</i>
          )
        </button>
        <button class="btn3 clear-item" @click="setType(6)" v-bind:class="{ active: resType == 6 }">
          已取消(
          <i>{{count7}}</i>
          )
        </button>
      </div>

      <div class="form-title">
        <div
          style="  display: flex;justify-content: space-between;;line-height: 46px;padding-left: 10px;padding-right: 10px;"
        >
          <div>筛选查询</div>
          <div>
            <el-select
              style="margin:0 10px"
              size="small"
              v-model="downloadNumber"
              placeholder="导出数量"
            >
              <el-option
                v-for="item in listNumber"
                :key="item.label"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-button size="small" @click="downloadOrderList()">导出订单</el-button>
          </div>
        </div>
      </div>
      <div style="background-color:#fff;" class="order-search-box">
        <el-row class="search" :gutter="10" style="height:60rpx">
          <el-col :span="2">
            <div class="label">输入搜索:</div>
          </el-col>
          <el-col :span="4">
            <el-input v-model="mobile_name" clearable size="small" placeholder="请输入用户姓名"></el-input>
          </el-col>
          <el-col :span="1.5">
            <div class="label">订单编号:</div>
          </el-col>
          <el-col :span="4">
            <el-input v-model="orderCode" clearable size="small" placeholder="请输入订单编号"></el-input>
          </el-col>
          <el-col :span="2">
            <div class="label">提交时间:</div>
          </el-col>
          <el-col :span="4">
            <template>
              <div class="block">
                <el-date-picker
                  v-model="create_time"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  size="small"
                  value-format="timestamp"
                ></el-date-picker>
              </div>
            </template>
          </el-col>
          <el-col :span="6" align="center"></el-col>
        </el-row>
        <el-row class="search" :gutter="10" style="height:60rpx">
          <el-col :span="2">
            <div class="label">业务员:</div>
          </el-col>
          <el-col :span="4">
            <el-input v-model="sale_name" clearable size="small" placeholder="请输入业务员姓名"></el-input>
          </el-col>
          <el-col :span="1.5">
            <div class="label">有效数据:</div>
          </el-col>
          <el-col :span="4">
            <el-switch v-model="true_value"></el-switch>
          </el-col>
          <el-col :span="2">订单提示:</el-col>
          <el-col :span="4">
            <el-switch @change="order_hint_change" v-model="order_hint"></el-switch>
            <iframe
              v-if="order_hint_yuyin"
              src="https://www.bioflin.com:83/mp3/new_order.mp3"
              allow="autoplay"
              hidden
            />
          </el-col>
          <el-col :span="6" align="center">
            <div class="filtrate_seek_sousuo" @click="geting()">搜索</div>
          </el-col>
        </el-row>
      </div>

      <div class="filtrate_center">
        <div class="center_list_head">
          <div class="center_list_head_left">
            <div>
              <i class="fas fa-bars"></i>
            </div>
            <div>数据列表</div>
          </div>
        </div>
        <div class="center_list_center"></div>
      </div>
      <el-table :data="tableData" border style="width: 100%" ref="multipleTable">
        <el-table-column prop="nickname" label="姓名" width="80" align="center"></el-table-column>

        <el-table-column prop="bind_mobile" width="120" label="电话" align="center"></el-table-column>
        <el-table-column prop="orderCode" width="200" label="订单编号" align="center"></el-table-column>
        <el-table-column prop="all_money" width="100" label="订单金额" align="center"></el-table-column>
        <el-table-column prop="pay_type" width="100" label="支付方式" align="center"></el-table-column>
        <el-table-column prop="create_time" label="下单时间" align="center"></el-table-column>
        <el-table-column prop="status" width="80" label="订单状态" align="center"></el-table-column>
        <el-table-column prop="sale_name" width="80" label="业务员" align="center"></el-table-column>
        <el-table-column
          v-if="finance_check == '1'"
          prop="finance_check"
          label="财务审核"
          align="center"
        ></el-table-column>
        <el-table-column label="操作" width="200" align="center" name="bianji">
          <template slot-scope="scope" style="display:flex;padding:0;margin:0">
            <router-link
              class="button1"
              target="_blank"
              :to="'./d_viewOrde/'+ scope.row.id + '/' + 1"
            >查看订单</router-link>
            <button
              @click="del(scope.row.id,scope.row.status1,scope.row.orderCode), shipments(scope.row.id)"
              class="button1"
            >{{scope.row.status1}}</button>
          </template>
        </el-table-column>
      </el-table>
      <div class="page_box clearfix" >
        <div class="page">
          <el-pagination
            background
            layout="total, prev, pager, next"
            :total="total"
            :page-size="15"
            @current-change="setPage"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!-- 点击确认发货 -->
    <el-dialog title="确认发货" :visible.sync="dialogFormVisible1" width="80%">
      <el-form>
        <el-form-item label="物流公司:">
          <template>
            <el-select v-model="value" placeholder="全部">
              <el-option
                v-for="item in option"
                :key="item.id"
                :label="item.com_name"
                :value="item.id"
              ></el-option>
            </el-select>
          </template>
        </el-form-item>
        <el-form-item v-if="value == 55" label="送货人:">
          <el-input style="width:356px" v-model="odd" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item v-else label="物流单号:">
          <el-input style="width:356px" v-model="odd" autocomplete="off"></el-input>
        </el-form-item>
        <!-- 出库信息 -->
        <div>
          <el-table :data="sendData" border type="index" style="width: 100%">
            <el-table-column prop="title" label="名称"></el-table-column>
            <el-table-column prop="item_no" label="货号"></el-table-column>
            <el-table-column prop="inventory" label="库存" width="100"></el-table-column>
            <el-table-column label="送货人">
              <template slot-scope="scope">
                <el-input v-model="sendData[scope.$index].send_member"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="送货时间">
              <template slot-scope="scope">
                <el-input placeholder="默认为现在" v-model="sendData[scope.$index].send_time"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="发票号">
              <template slot-scope="scope">
                <el-input v-model="sendData[scope.$index].duty_code"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="出库数量">
              <template slot-scope="scope">
                <el-input v-model="sendData[scope.$index].number"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="客户">
              <template slot-scope="scope">
                <el-input v-model="sendData[scope.$index].to"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="备注" width="200">
              <template slot-scope="scope">
                <el-input v-model="sendData[scope.$index].remark1"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="submit()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 确认采购 -->
    <el-dialog title="确认采购" :visible.sync="dialogFormVisible2" width="80%">
      <el-form>
        <el-form-item label="订单编号:">
          <el-input style="width:500px" v-model="order" autocomplete="off" :disabled="true"></el-input>
        </el-form-item>
      </el-form>
      <div>
        <el-table :data="purchaseData" border type="index" style="width: 100%">
          <el-table-column prop="title" label="名称"></el-table-column>
          <el-table-column prop="item_no" label="货号"></el-table-column>
          <el-table-column prop="specification" label="规格"></el-table-column>
          <el-table-column prop="brand" label="品牌"></el-table-column>
          <el-table-column prop="inventory" label="库存" width="50"></el-table-column>
          <el-table-column label="供应商" width="250">
            <template slot-scope="scope">
              <el-autocomplete
                style="width:100%"
                v-model="purchaseData[scope.$index].supplier"
                :fetch-suggestions="querySearchAsync"
                @select="supplierSelect"
              ></el-autocomplete>
            </template>
          </el-table-column>
          <el-table-column label="价格">
            <template slot-scope="scope">
              <el-input v-model="purchaseData[scope.$index].purchasePrice"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="数量">
            <template slot-scope="scope">
              <el-input v-model="purchaseData[scope.$index].number"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="到货期">
            <template slot-scope="scope">
              <el-input v-model="purchaseData[scope.$index].days" placeholder="单位天"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="备注" width="250">
            <template slot-scope="scope">
              <el-input v-model="purchaseData[scope.$index].remark"></el-input>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="submit1()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import "./../assets/all.css";
export default {
  name: "list",
  data() {
    return {
      order_hint_yuyin: false,
      order_hint: false,
      time: null,
      serve: this.$store.state.serve,
      showNoAccess: false,
      order: "",
      order_date: "",
      id: "",
      dialogFormVisible1: false,
      dialogFormVisible2: false,
      number: "",
      name: "",
      create_time: "",
      username: this.$cookies.get("username"),
      token: this.$cookies.get("token"),
      page: null,
      total: 0,
      resType: null,
      option: [],
      value: "",
      odd: "",
      msg: "",
      //
      count0: 0,
      count1: 0, //未付款
      count2: 0, //待采购
      count3: 0, //待发货
      count4: 0, //已发货
      count5: 0, //待评价
      count6: 0, //已完成
      count7: 0, //取消
      name: null,
      category: null,
      categorys: [],
      brand: null,
      brands: [],
      tableData: [],
      multipleSelection: [],
      isIndeterminate: true,
      select: false,
      selectAll: false,
      checked: [],
      idString: "",
      msg1: "",
      finance_check: 0,
      purchaseData: [],
      purchaseForm: [],
      sendData: [],
      restaurants: [],
      listNumber: [
        { value: 10, label: "10条" },
        { value: 30, label: "30条" },
        { value: 50, label: "50条" },
        { value: 100, label: "100条" },
        { value: 500, label: "500条" },
        { value: 1, label: "全部" }
      ],
      downloadType: [
        { value: 1, label: "详细信息" },
        { value: 2, label: "简洁信息" }
      ],
      downloadNumber: "",
      true_value: false,
      orderCode: "",
      sale_name: "",
      mobile_name: "",
      download_type: ""
    };
  },
  created() {
    if (this.$route.query.type) {
      this.setType(this.$route.query.type);
    }
    this.$store.state.topActiveId = 3;
    this.$store.state.leftTitle = "订单列表";
    this.geting();
    this.heading();
  },
  watch: {
    //监听全选状态
    selectAll(v) {
      if (v == false) {
        this.$refs.multipleTable.clearSelection();
      } else {
        this.$refs.multipleTable.clearSelection();
        this.$refs.multipleTable.toggleAllSelection();
      }
    },
    order_hint_yuyin: {
      handler(newName, oldName) {},
      immediate: true
    }
  },
  beforeDestroy() {
    if (this.time) {
      clearInterval(this.time);
    }
  },
  methods: {
    order_hint_change(e) {
      const _this = this;
      _this.time = setInterval(function() {
        if (_this.order_hint) {
          if (_this.order_hint_yuyin == true) {
            _this.order_hint_yuyin = false;
            // console.log("自动关闭");
          } else {
            //开启提示
            _this.axios.get(_this.serve + "/has_new_order").then(res => {
              if (res.data == "0") {
                // console.log("没有新订单");
                //没有新订单
                _this.order_hint_yuyin = false;
              } else if (res.data == "1") {
                // console.log("有新订单");
                //有新的订单
                _this.order_hint_yuyin = true;
              }
            });
          }
        } else {
          clearInterval(_this.time);
        }
      }, 30000);
    },
    alert_success(message) {
      this.$message({
        type: "success",
        message: message,
        offset: 200
      });
    },
    alert_error(message) {
      this.$message({
        type: "error",
        message: message,
        offset: 200
      });
    },
    downloadOrderList() {
      var where = {
        token: this.token,
        username: this.username,
        create_time: this.create_time,
        status: this.resType,
        true_value: this.true_value,
        sale_name: this.sale_name,
        limit: this.downloadNumber
      };
      if (this.downloadNumber == "") {
        this.alert_error("请选择要导出的条数");
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: "正在下载..",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.axios
        .get(this.serve + "/admin/download_order_list", {
          params: where,
          responseType: "blob",
          onDownloadProgress: function(progressEvent) {}
        })
        .then(res => {
          if(res.data.code == '403'){
              this.$message.error(res.data.code);
          }
          if (res.data.type == "text/html") {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            let fileName = "宝枫林订单详情列表.xlsx";
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            this.loading = false;

            this.$message({
              type: "success",
              message: "导出成功成功",
              offset: 200
            });
          } else {
  
            this.$message({
              showClose: true,
              message: "没有权限导出或导出失败请重新操作",
              type: "error",
              offset: 200
            });
          }
          loading.close();
        })
        .catch(er => {
          this.loading = false;
          loading.close();
          this.$message({
            showClose: true,
            message: "导出失败请重新操作",
            type: "error",
            offset: 200
          });
        });
    },
    getSupplier(name) {
      this.axios
        .get(this.serve + "/admin/get_supplier_list", {
          params: {
            name: name,
            username: this.username,
            token: this.token
          }
        })
        .then(res => {
          var data = res.data;
          if (data.status == "success") {
            var row = [];
            var data1 = data.data;
            for (var i in data1) {
              var a = {};
              a.value = data1[i];
              row[i] = a;
            }
            this.restaurants = row;
          } else {
            this.restaurants = [];
          }
        });
    },
    querySearchAsync(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createStateFilter(queryString))
        : restaurants;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 3000 * Math.random());
    },
    createStateFilter(queryString) {
      return state => {
        return (
          state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    supplierSelect(item) {},
    sendInfo(orderCode) {
      this.axios
        .get(this.serve + "/admin/sendInfo", {
          params: {
            username: this.username,
            token: this.token,
            orderCode: orderCode
          }
        })
        .then(res => {
          var data = res.data;
          if (data.status == "success") {
            this.sendData = data.data;
          } else {
            this.sendData = [];
          }
        });
    },
    purchaseInfo(orderCode) {
      this.axios
        .get(this.serve + "/admin/purchaseInfo", {
          params: {
            username: this.username,
            token: this.token,
            orderCode: orderCode
          }
        })
        .then(res => {
          var data = res.data;
          if (data.status == "success") {
            this.purchaseData = data.data;
          } else {
            this.purchaseData = [];
          }
        });
    },
    shipments(id) {
      //确认发货弹窗
      const _this = this;
      this.axios
        .get(this.serve + "/admin/get_express_list", {
          params: {
            username: this.username,
            token: this.token
          }
        })
        .then(res => {
          _this.option = [];
          var json = res.data.data.results;
          _this.id = id;
          for (var key in json) {
            if (json[key].status == "1") {
              _this.option.push(json[key]);
            }
          }
        });
    },
    open4() {
      //错误时返回的息状态
      this.$message({
        //成功时 返回的状态
        message: this.msg1,
        type: "error",
        offset: 200
      });
    },
    open() {
      this.$message({
        //成功时 返回的状态
        message: "发货成功",
        type: "success",
        offset: 200
      });
    },
    submit(id) {
      //确认发货弹窗提交
      const _this = this;
      //如果发货数量>库存无法发货
      this.axios
        .get(this.serve + "/admin/shipments", {
          params: {
            username: this.username,
            token: this.token,
            order_id: this.id,
            express_com: this.value,
            express_code: this.odd,
            order_info: JSON.stringify(this.sendData)
          }
        })
        .then(res => {
          this.msg1 = res.data.msg;
          if (res.data.status == "success") {
            _this.geting();
            _this.open();
            _this.heading();
          }else if(res.data.code == "403"){
            _this.$message.error(res.data.msg);
          } else if (res.data.status == "error") {
            _this.open4();
            _this.geting();
            _this.heading();
          }
          this.dialogFormVisible1 = false;
        });
    },
    red(id) {
      this.$router.push("d_viewOrde?id=" + id);
    },
    del(id, status1, orderCode) {
      if (status1 == "确认发货") {
        this.dialogFormVisible1 = true;
        this.sendInfo(orderCode);
      }
      if (status1 == "提醒付款") {
        this.payment(orderCode);
      }
      if (status1 == "确认采购") {
        this.dialogFormVisible2 = true;
        this.order = orderCode;
        this.purchaseInfo(orderCode);
        this.getSupplier();
      }
      if (status1 == "订单跟踪") {
        this.$router.push({
          path: "d_orderTail/" + id
        });
      }
    },
    submit1() {
      var qs = require("qs");
      var formData = {
        username: this.username,
        token: this.token,
        orderCode: this.order,
        order_date: this.order_date,
        order_info: JSON.stringify(this.purchaseData)
      };
      this.axios
        .post(this.serve + "/admin/buy_product", qs.stringify(formData))
        .then(res => {
          if (res.data.status == "success") {
            this.dialogFormVisible2 = false;
            this.geting();
            this.heading();
            this.$message({
              type: "success",
              message: "采购成功!",
              offset: 200
            });
          } else if (res.data.status == "error") {
            this.$message({
              type: "error",
              message: res.data.msg,
              offset: 200
            });
          }
        });
    },
    payment(orderCode) {
      //提醒付款
      this.$confirm("此操作将提醒付款, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.axios
            .get(this.serve + "/admin/warn_user_pay", {
              params: {
                username: this.username,
                token: this.token,
                orderCode
              }
            })
            .then(res => {
              this.msg = res.data.msg;
              if (res.data.status == "success") {
                this.geting();
                this.heading();
                this.$message({
                  type: "success",
                  message: "提醒成功!",
                  offset: 200
                });
              } else if (res.data.status == "error") {
                this.$message({
                  type: "error",
                  message: this.msg,
                  offset: 200
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
            offset: 200
          });
        });
    },
    setType(type) {
      //点击分类 订单
      this.resType = type;
      this.geting();
      if (type == 1) {
        this.finance_check = 1;
      } else {
        this.finance_check = 0;
      }
    },
    setPage(v) {
      //分页
      this.page = v;
      this.geting(v);
      this.selectAll = false;
    },
    heading() {
      this.axios(this.serve + "/admin/order_header", {
        params: {
          username: this.username,
          token: this.token
        }
      }).then(res => {
        if (res.data.status == "success") {
          var count = res.data.data;
          this.count0 = count.all_num;
          this.count1 = count.num_0;
          this.count2 = count.num_1;
          this.count3 = count.num_2;
          this.count4 = count.num_3;
          this.count5 = count.num_4;
          this.count6 = count.num_5;
          this.count7 = count.num_6;
        }
      });
    },
    geting(page) {
      //请求数据
      var that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      const loading = this.$loading({
        lock: true,
        text: "正在加载...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      var formData = {
        page: page ? page : this.page,
        token: this.token,
        username: this.username,
        orderCode: this.orderCode,
        create_time: this.create_time,
        status: this.resType,
        true_value: this.true_value,
        sale_name: this.sale_name,
        name: this.mobile_name
      };
      this.axios
        .get(this.serve + "/admin/order_list", {
          params: formData
        })
        .then(res => {
          that.tableData = [];
          var json = res.data.data;
          if (res.data.status == "success") {
            that.total = res.data.data.total;
            that.page = res.data.data.now_page;
            var count = res.data.data;

            for (var key in json.results) {
              json.results[key].all_money = json.results[key].all_money + "￥";
              if (json.results[key].status == 0) {
                json.results[key].status = "待付款";
                json.results[key].status1 = "提醒付款";
              } else if (json.results[key].status == 1) {
                json.results[key].status = "待采购";
                json.results[key].status1 = "确认采购";
              } else if (json.results[key].status == 2) {
                json.results[key].status = "待发货";
                json.results[key].status1 = "确认发货";
              } else if (json.results[key].status == 3) {
                json.results[key].status = "待收货";
                json.results[key].status1 = "订单跟踪";
              } else if (json.results[key].status == 4) {
                json.results[key].status = "待评价";
              } else if (json.results[key].status == 5) {
                json.results[key].status = "已完成";
              } else if (json.results[key].status == 6) {
                json.results[key].status = "已取消";
              }
              var time = json.results[key].create_time;
              var timeNew = new Date(parseInt(time) * 1000)
                .toLocaleString()
                .replace(/:\d{1,2}$/, " ");
              json.results[key].create_time = timeNew;
              that.tableData.push(json.results[key]);
              if (json.results[key].pay_type == 1) {
                json.results[key].pay_type = "在线支付";
              } else if (json.results[key].pay_type == 2) {
                json.results[key].pay_type = "账期支付";
              }
              if (json.results[key].finance_check == 1) {
                json.results[key].finance_check = "审核通过";
              } else if (json.results[key].finance_check == 0) {
                json.results[key].finance_check = "未审核";
              }
            }
          } else {
            if (res.data.msg == "无权访问") {
              this.showNoAccess = true;
            }
            this.tableData = [];
            this.total = 0;
            this.now_page = 1;
          }
          loading.close();
        });
    }
  }
};
</script>
<style lang="scss">
.list {
  .order-search-box {
    width: 1054px;
    height: 130px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
  }
  background: #f5f5f5;
  color: #333;
  padding-bottom: 100px;
  .topBar {
    margin-bottom: 40px;
  }
  .filtrate_seek_sousuo {
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    width: 74px;
    height: 28px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    position: absolute;
    right: 18px;
    top: 29px;
    cursor: pointer;
  }
  .el-pagination {
    text-align: left;
  }
  .filtrate_seek_sousuo:hover {
    background-color: #0099ff;
    color: #fff;
  }

  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }
  .filtrate_center {
    margin-top: 19px;
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .button1 {
    // border: 0;
    border: none;
    outline: none;
    background: none;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    cursor: pointer;
  }
  .button1:hover {
    color: #0099ff;
  }
  .search {
    height: 60px;
    display: flex;
    justify-content: center;
  }
  .cell {
    color: #606266 !important;
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    display: flex;
    justify-content: space-between;
    .center_list_head_left {
      display: flex;
      align-items: center;
      > div {
        margin-left: 10px;
      }
    }
    .center_list_head_rig {
      width: 100px;
      height: 30px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 12px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      margin: 7px 30px 0 0;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
    }
    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }

  .menu1 {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .btn3 {
      margin-right: 0;
      i {
        font-style: normal;
        color: #f64e62;
      }
    }
    .btn3:hover i {
      color: #fff;
    }
    .active i {
      color: #fff;
    }
  }
  .search .el-col {
    line-height: 80px;
  }
  .label {
    text-align: right;
    padding-right: 10px;
    font-size: 14px;
  }
  .table {
    background-color: #fff;
    padding: 10px 20px;
    .el-tree-node {
      font-size: 16px;
      padding: 5px 0;
    }
  }
  .el-table_1_column_3 .cell {
    overflow: hidden;
    text-align: center;
  }
}
</style>